import React, { useEffect, useState } from 'react';
import { usePlaidLink } from 'react-plaid-link';
import PropTypes from 'prop-types';

import Spinner from '../../../../../../../components/Spinner';
import { getLinkToken } from '../../../../../../../services/plaidService';

import styles from './AddPlaidAccount.module.scss';

const AddPlaidAccount = ({ config }) => {
  const {
    open: openPlaidLink,
    ready: plaidReady,
    // error: plaidError,
  } = usePlaidLink(config);

  useEffect(() => {
    if (plaidReady) {
      openPlaidLink();
    }
  }, [plaidReady]);

  return (
    <div className={styles.loader}>
      <Spinner secondary />
    </div>
  );
};

AddPlaidAccount.propTypes = {
  config: PropTypes.object,
};

const PlaidWrapper = ({
  onBankAccountAdded,
  offerManualMicroDeposits,
  onLoaded,
  onBack,
}) => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    if (!open) return;

    const loadPlaidConfig = async () => {
      const token = await getLinkToken({
        manualMicrodepositsFlow: offerManualMicroDeposits,
      });
      setConfig({
        token,
        onSuccess: onBankAccountAdded,
        onExit: (reason) => {
          console.log('onExit reason', reason);
          onBack();
        },
        onLoad: () => {
          onLoaded();
        },
      });
    };
    loadPlaidConfig();
  }, [onBankAccountAdded]);

  if (!config)
    return (
      <div className={styles.loader}>
        <Spinner secondary />
      </div>
    );
  return <AddPlaidAccount config={config} />;
};

PlaidWrapper.propTypes = {
  onBack: PropTypes.func,
  onLoaded: PropTypes.func,
  offerManualMicroDeposits: PropTypes.bool,
  onBankAccountAdded: PropTypes.func,
};

export default PlaidWrapper;
